// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class NewsAIService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getQueryChoices(securityId) {
        const url = this.urlsService.getUrl(this.urlsService.NEWS.AI_CHAT_QUERY_CHOICES, { securityId });
        return this.ajaxService.getDataObserveBody(url);
    }
}
NewsAIService.ɵfac = function NewsAIService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NewsAIService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
NewsAIService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NewsAIService, factory: NewsAIService.ɵfac, providedIn: 'root' });
